import { createAction, props } from '@ngrx/store';
import { MaintanceStatusReponse } from '@cpd-app/generated';

export const getMaintance = createAction('[Maintance] get maintance');

export const getMaintanceSuccess = createAction(
  '[Maintance] get maintance success',
  props<{ response: MaintanceStatusReponse }>(),
);

export const getMaintanceFailure = createAction(
  '[Maintance] get maintance failure',
  props<{ error: any }>(),
);
